import store from '@/store';
import { FETCH_ARTICLES_BY_CATEGORY } from '@/store/actions/article.actions';
import { isDefined } from '@/common/utils/utils';
import { SELECT_CATEGORY } from '@/store/actions/category.actions';

export const CategoryArticlesLoaded = (to, from, next) => {
  const categorySlugParam = to.params['category'];
  const categories = store.getters.categories;
  const category = categories.find(category => category.slug === categorySlugParam);

  if (isDefined(category)) {
    store.dispatch(SELECT_CATEGORY, category);

    if (store.getters.getArticleCategoriesLoaded(category.id)) {
      return next();
    }

    return store.dispatch(FETCH_ARTICLES_BY_CATEGORY, category.id)
      .then(() => next())
      .catch(() => next({name: 'error'}));
  } else {
    return next({name: '404'});
  }
};
